export default "__VITE_ASSET__BROuc8kx__"